import { render, staticRenderFns } from "./menuAdmin.vue?vue&type=template&id=3cce0d3a&scoped=true"
import script from "./menuAdmin.vue?vue&type=script&lang=js"
export * from "./menuAdmin.vue?vue&type=script&lang=js"
import style0 from "./menuAdmin.vue?vue&type=style&index=0&id=3cce0d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cce0d3a",
  null
  
)

export default component.exports